define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-our-franchise-brand';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandCnHeaderMenuId, 'animate__faster animate__fadeIn', 'our-franchise-brand', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandDcHeaderMenuId, 'animate__faster animate__fadeIn', 'our-franchise-brand', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandHboHeaderMenuId, 'animate__faster animate__fadeIn', 'our-franchise-brand', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandMoreHeaderMenuId, 'animate__faster animate__fadeIn', 'our-franchise-brand', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandWagHeaderMenuId, 'animate__faster animate__fadeIn', 'our-franchise-brand', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandWizardWorldHeaderMenuId, 'animate__faster animate__fadeIn', 'our-franchise-brand', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandDcAnimMainId, 'animate__faster animate__slideInLeft', 'our-franchise-brand', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandDcAnimBoxId, 'animate__faster animate__slideInRight', 'our-franchise-brand', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandWizardWorldAnimMainId, 'animate__faster animate__slideInLeft', 'our-franchise-brand', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandWizardWorldAnimBoxId, 'animate__faster animate__slideInRight', 'our-franchise-brand', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandHboAnimMainId, 'animate__faster animate__slideInLeft', 'our-franchise-brand', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandHboAnimBoxId, 'animate__faster animate__slideInRight', 'our-franchise-brand', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandWagAnimMainId, 'animate__faster animate__slideInLeft', 'our-franchise-brand', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandWagAnimBoxId, 'animate__faster animate__slideInRight', 'our-franchise-brand', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandCnAnimMainId, 'animate__faster animate__slideInLeft', 'our-franchise-brand', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandCnAnimBoxId, 'animate__faster animate__slideInRight', 'our-franchise-brand', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandMoreAnimMainId, 'animate__faster animate__slideInLeft', 'our-franchise-brand', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleOurFranchiseBrandMoreAnimBoxId, 'animate__faster animate__slideInRight', 'our-franchise-brand', {});
            };

            view.bind = function () {

            };

            view.methods = {

            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
